import basicTheme from '../basicTheme.js';

const dividerStyleOverrides = {
    styleOverrides: {
        root: {
            borderColor: basicTheme.palette.N30.main,
            margin: basicTheme.spacing(1, 0),
        },
    },
};

export { dividerStyleOverrides as default };
//# sourceMappingURL=MuiDivider.js.map
